function setWOGAA(){
  if (window.location.hostname == 'www.onemap.gov.sg') {
    // import('https://assets.wogaa.sg/scripts/wogaa.js')
    // import('https://www.googletagmanager.com/gtag/js?id=G-ZDGXN3LSHP')
    // window.dataLayer = window.dataLayer || [];

    // function gtag() {
    //   window.dataLayer.push(arguments);
    // }
    // gtag('js', new Date());
    // gtag('config', 'G-ZDGXN3LSHP');

    return 'G-4N7MQ2Q4P5'

  } else {
    // import('https://assets.dcube.cloud/scripts/wogaa.js')
    // import('https://www.googletagmanager.com/gtag/js?id=G-CVMJC2J305')
    // window.dataLayer = window.dataLayer || [];

    // function gtag() {
    //   window.dataLayer.push(arguments);
    // }
    // gtag('js', new Date());

    // gtag('config', 'G-CVMJC2J305');
    return 'G-C4Z0XPRTLR'

  }
}

export default setWOGAA